import { Copy, GitCompareArrows, CheckSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { CullGrid } from '@/components/culling/CullGrid';
import { CULL } from '@/constants/testIds';

export const DuplicateGroups = ({ groups, imagesById, selectedIds, onToggle, onSelectGroup, onCompareGroup }) => {
  if (!groups.length) return null;
  return (
    <div data-testid={CULL.groups} className="space-y-5">
      {groups.map((g) => {
        const members = (g.image_ids || []).map((id) => imagesById[id]).filter(Boolean);
        if (members.length < 2) return null;
        return (
          <section key={g.id} data-testid={CULL.group(g.id)} className="rounded-2xl border border-[hsl(var(--lxra-border))] bg-[#0F0F10] p-4">
            <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
              <p className="flex items-center gap-2 text-xs uppercase tracking-[0.12em] text-[hsl(var(--lxra-muted))]"><Copy className="h-3.5 w-3.5 text-[hsl(var(--lxra-gold))]" /> Group {g.id.replace('g', '#')} · {members.length} near-identical frames</p>
              <div className="flex items-center gap-2">
                <Button size="sm" variant="outline" data-testid={CULL.groupSelect(g.id)} onClick={() => onSelectGroup(members.map((m) => m.id))} className="h-8 border-[hsl(var(--lxra-border))] bg-transparent text-[11px] uppercase tracking-[0.08em] text-[hsl(var(--lxra-fg))] hover:border-[hsl(var(--lxra-gold))] hover:text-[hsl(var(--lxra-gold))]"><CheckSquare className="mr-1.5 h-3.5 w-3.5" /> Select group</Button>
                <Button size="sm" data-testid={CULL.groupCompare(g.id)} onClick={() => onCompareGroup(members.slice(0, 4).map((m) => m.id))} className="h-8 bg-[hsl(var(--lxra-gold))] text-[11px] uppercase tracking-[0.08em] text-[#0A0A0A] hover:bg-[hsl(var(--lxra-gold-hover))]"><GitCompareArrows className="mr-1.5 h-3.5 w-3.5" /> Compare</Button>
              </div>
            </div>
            <CullGrid images={members} selectedIds={selectedIds} onToggle={onToggle} />
          </section>
        );
      })}
    </div>
  );
};
